let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9pmDz")).then(() => parcelRequire('c7EOd'));